export default __webpack_public_path__ + "navigation-examples-beta-query-parameters-thumbnail-480-fdf7696cf83c26342c920f3e41202d9a.webp";